import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-instant-results',
    templateUrl: './instant-results.component.html',
    styleUrls: ['../application.component.css', './instant-results.component.css']
})
export class InstantResultsComponent implements OnInit {
    
    token: any;

    @Input() dbaName: any = '';
    @Input() offers: any = { offerList: [] };

    constructor(private route: ActivatedRoute, private router: Router) { }

    ngOnInit(): void {
        this.token = this.route.snapshot.queryParams.token;
    }

    onContinueClick() {
        this.router.navigateByUrl('/home');
    }
}
